import track from 'redux-analytics'
import debounce from 'lodash/debounce'

import DesktopHelpers from 'helpers/DesktopHelpers'

export const ANALYTICS_INIT = 'ANALYTICS_INIT'
export function initAnalytics(version, user, organization) {
  return {
    type: ANALYTICS_INIT,
    payload: { version, user, organization },
  }
}

// for Intercom, force update to ensure messaging liveness
const intercomLiveUpdate = debounce(() => {
  window.Intercom && window.Intercom('update', {})
}, 5 * 1000 /* 5 s */)

function usingAnalyticsJS({ type, payload }) {
  if (!window.analytics) {
    return
  }
  switch (type) {
    case ANALYTICS_INIT:
      const { user, organization } = payload
      const traits = {
        // STANDARD
        id: user.id,
        name: user.displayName,
        email: user.email,
        createdAt: user.inviteAcceptedAt || user.createdAt,
        company: {
          id: organization.id,
          name: organization.name,
          domain: organization.domain,
        },
        // Extra (for our mails & stuff)
        username: user.username,
        organizationRole: user.organizationRole,
        companyDomain: organization.domain,
        organizationFeatureFlags: organization.featureFlags,
        isUsingDesktopApp: DesktopHelpers.isAppDesktop(),
      }
      const options = {
        Intercom: { user_hash: user.intercomIdentifierHash },
        page: { title: 'App' }, // To obfuscate the page title on analytics.
      }

      window.analytics.identify(user.id, traits, options)
      window.analytics.group(organization.id, {
        // STANDARD
        id: organization.id,
        name: organization.name,
        createdAt: organization.createdAt,
        plan: organization.product,
        // AMPLITUDE
        groupType: 'organizationId',
        groupValue: organization.id,
        // EXTRAS
        featureFlags: organization.featureFlags,
      })
      return
    default:
      if (!window.analytics) {
        return
      }
      window.analytics.track(type, payload, {
        context: {
          page: {
            title: 'App', // To obfuscate the page title on analytics.
          },
        },
      })
      intercomLiveUpdate()
  }
}

export default track(usingAnalyticsJS)
